// extracted by mini-css-extract-plugin
export var askAiIcon = "_og-j";
export var category = "_og-9";
export var categoryHeader = "_og-e";
export var container = "_og-0";
export var group = "_og-a";
export var groupItems = "_og-f";
export var groupSeparator = "_og-k";
export var loading = "_og-1";
export var noResults = "_og-3";
export var placeholder = "_og-2";
export var resultContent = "_og-5";
export var resultIcon = "_og-c";
export var resultItem = "_og-g";
export var resultMeta = "_og-8";
export var resultSubtitle = "_og-7";
export var resultSuffix = "_og-i";
export var resultTitle = "_og-6";
export var resultsList = "_og-4";
export var searchGroup = "_og-d";
export var selected = "_og-h";
export var subgroup = "_og-b";